export const login = {
    header: "ログイン",
    items: {
        username: {
            placeholder: "ユーザーネームを入力してください",
            label: "ユーザー名",
            type: "text",
        },
        password: {
            placeholder: "パスワードを入力する",
            label: "パスワード",
            type: "password",
        },
    },
    submit: {
        placeholder: "送信",
        label: "送信",
        type: "submit",
    },
    cancel: {
        label: "キャンセル",
    },
};
